import { createApiReducers, createApiReducerInitialState } from '../../../Helpers/reducer'
import {
  SELECT_ACTION,
  GET_ACTIONS,
  GET_CONTACT_GOAL_CLASSIFIER,
  GET_CONTACT_GOAL_STATUS,
  GET_CONTACT_GOAL_TIME,
  GET_CONTACT_GOAL_TYPE,
  GET_CONTACT_GOAL_WHO,
  GET_EVALUATE_PEOPLE,
  GET_VIEW_CONTACT_GOAL_PEOPLE,
  SAVE_CONTACT_GOAL,
} from './createTask.constants'

const initialState = {
  selectedAction: null,
  ...createApiReducerInitialState('actions', []),
  ...createApiReducerInitialState('contactGoalClassifier', {}),
  ...createApiReducerInitialState('contactGoalStatus', {}),
  ...createApiReducerInitialState('contactGoalTime', {}),
  ...createApiReducerInitialState('contactGoalType', {}),
  ...createApiReducerInitialState('contactGoalWho', {}),
  ...createApiReducerInitialState('evaluatePeople', []),
  ...createApiReducerInitialState('viewContactGoalPeople', []),
  ...createApiReducerInitialState('contactGoalSaved', {}),
}

export default (state = initialState, action) => {
  const reducers = {
    [SELECT_ACTION]: (state, action) => ({
      ...state,
      selectedAction: action.selectedAction,
    }),
    ...createApiReducers(GET_ACTIONS, 'actions', []),
    ...createApiReducers(GET_CONTACT_GOAL_CLASSIFIER, 'contactGoalClassifier', {}),
    ...createApiReducers(GET_CONTACT_GOAL_STATUS, 'contactGoalStatus', {}),
    ...createApiReducers(GET_CONTACT_GOAL_TIME, 'contactGoalTime', {}),
    ...createApiReducers(GET_CONTACT_GOAL_TYPE, 'contactGoalType', {}),
    ...createApiReducers(GET_CONTACT_GOAL_WHO, 'contactGoalWho', {}),
    ...createApiReducers(GET_EVALUATE_PEOPLE, 'evaluatePeople', []),
    ...createApiReducers(GET_VIEW_CONTACT_GOAL_PEOPLE, 'viewContactGoalPeople', []),
    ...createApiReducers(SAVE_CONTACT_GOAL, 'contactGoalSaved', {}, true), //TODO May be different
  }

  return reducers[action.type] ? reducers[action.type](state, action) : state
}
